//MyCenterModal
import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  Dialog,
  DialogContent,
  Slide,
  DialogTitle,
  DialogActions,
  Button,
  Typography,
  Tooltip,
  IconButton
} from '@material-ui/core';
import CloseIcon from '@mui/icons-material/Close';
const styles = (theme) => ({
  dialog: {
    borderRadius: 0,
  },
  buttonSignup: {
    boxShadow: 'none',
    fontWeight: 400,
    color: '#ffffff',
    backgroundColor: 'green',
    borderRadius: 0,
    border: '1px solid green',
    padding: '5px 22px',
    '&:hover': {
      color: '#ffffff',
      backgroundColor: 'green',
    }
  },
  buttonLogin: {
    boxShadow: 'none',
    fontWeight: 400,
    color: '#ffffff',
    backgroundColor: theme.palette.primary.main,
    borderRadius: 0,
    border: '1px solid red',
    padding: '5px 22px',
    '&:hover': {
      color: '#ffffff',
      backgroundColor: theme.palette.primary.main,
    }
  },
  DialogTitle: {
    padding: "10px 24px",
  },
  myTitle: {
    lineHeight: '2.5rem',
    float: "left",
    color: "#ffffff",
    fontWeight: 600
  },
  closeIcon: {
    color: "#ffffff",
    cursor: 'pointer',
    float: 'right'
  },
  dialogcontent: {
    backgroundColor: '#fcfcfc',
    padding: '1rem 1.5rem'
  }
});


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class MyCenterModal extends Component {
  render() {
    const { classes, children } = this.props;
    return (
      <Dialog
        maxWidth="xs"
        fullWidth
        className={classes.dialog}
        open={Boolean(this.props.open)}
        onClose={this.props.onClose}
        TransitionComponent={Transition}
      >
        <DialogTitle
          style={{ backgroundColor: this.props.bgColor ? this.props.bgColor : "gray" }}
          className={classes.DialogTitle}
        >
          <Typography className={classes.myTitle} variant="h4" >
            {this.props.title}
          </Typography>

          <Tooltip arrow title="Close">
            <IconButton
              className={classes.closeIcon}
              size="small"
              onClick={this.props.onClose}
            >
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </DialogTitle>

        <DialogContent
          className={classes.dialogcontent}
          dividers>
          {children}
        </DialogContent>

        <DialogActions>
          <Button
            onClick={this.props.onClose}
            size="large"
            fullWidth
            variant="contained"
            className={classes.buttonLogin}
          >
            close
          </Button>

          <Button
            onClick={this.props.handleSubmit}
            size="large"
            fullWidth
            variant="contained"
            className={classes.buttonSignup}
            disabled={this.props.isActive ? false : true}
          >
            submit
          </Button>

        </DialogActions>
      </Dialog>
    )
  }
}

export default withStyles(styles)(MyCenterModal);